/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBoxDash = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        clipRule="evenodd"
        d="M8.293 2.293A1 1 0 0 1 9 2h1v2h-.586l-.457.457-1.414-1.414zM14 4h-2V2h2zm4 0h-2V2h2zm2-2h1a1 1 0 0 1 1 1v1h-.586l-.457.457L20.5 4H20v-.5l-.457-.457.457-.457zM7.457 5.957l-1.5 1.5-1.414-1.414 1.5-1.5zm12 0-1.5 1.5-1.414-1.414 1.5-1.5zM22 6v2h-2V6zM4 9.414V10H2V9a1 1 0 0 1 .293-.707l.75-.75L3.5 8H4v.5l.457.457zm12 0 .457-.457-1.414-1.414-.457.457H14v2h2zM8 10H6V8h2zm4 0h-2V8h2zm10 0v2h-2v-2zM2 14v-2h2v2zm12 0v-2h2v2zm8 0v1a1 1 0 0 1-.293.707l-.75.75-1.414-1.414.457-.457V14zM2 18v-2h2v2zm12 0v-2h2v2zm5.457-.043-1.5 1.5-1.414-1.414 1.5-1.5zm-3 3-.75.75A1 1 0 0 1 15 22h-1v-2h.586l.457-.457.457.457h.5v.5zM2 21v-1h2v2H3a1 1 0 0 1-1-1zm6 1H6v-2h2zm4 0h-2v-2h2z"
        fill="currentcolor"
        fillRule="evenodd"
      />
    </g>
  </Icon>
);
export { SvgBoxDash as BoxDash };
